'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _lazyLoader = require('../../utils/lazyLoader');

var _lazyLoader2 = _interopRequireDefault(_lazyLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  'image': 'ccl-45bd106b75353ec9',
  'fallback': 'ccl-d5fa9efd412993ea',
  'content': 'ccl-0ca6410c5e153903',
  'fadeout': 'ccl-0220f29e0da451eb'
};

/**
 * Component to lazy-load a background image around some content.
 */

var BackgroundImage = function (_React$Component) {
  _inherits(BackgroundImage, _React$Component);

  function BackgroundImage(props) {
    _classCallCheck(this, BackgroundImage);

    var _this = _possibleConstructorReturn(this, (BackgroundImage.__proto__ || Object.getPrototypeOf(BackgroundImage)).call(this, props));

    _this.state = {
      isVisible: false
    };

    _this.lazyLoad = _this.props.lazyLoader || _lazyLoader2.default;
    _this.onVisible = _this.onVisible.bind(_this);
    return _this;
  }

  _createClass(BackgroundImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.lazyLoad.isSupported) {
        this.lazyLoad.observe(this.imageContainer, this.onVisible);
      } else {
        this.onVisible();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.lazyLoad.isSupported) {
        this.lazyLoad.unobserve(this.imageContainer);
      }
    }
  }, {
    key: 'onVisible',
    value: function onVisible() {
      var _this2 = this;

      var image = new Image();
      image.onload = function () {
        _this2.setState(function () {
          return {
            isVisible: true
          };
        });
      };

      image.src = this.imageUrl();
    }
  }, {
    key: 'imageUrl',
    value: function imageUrl() {
      var imageUrl = this.props.src;

      if (this.imageContainer && imageUrl.match('{(w|h)}')) {
        var ratio = window.devicePixelRatio || 1;
        imageUrl = imageUrl.replace('{w}', this.imageContainer.offsetWidth * ratio).replace('{h}', this.imageContainer.offsetHeight * ratio).replace(/{&.*}/, '');
      }

      return imageUrl;
    }
  }, {
    key: 'imageStyle',
    value: function imageStyle() {
      var imageUrl = this.imageUrl();

      return this.state.isVisible ? { backgroundImage: 'url(\'' + imageUrl + '\')' } : {};
    }
  }, {
    key: 'placeholderImageStyle',
    value: function placeholderImageStyle() {
      var imageUrl = this.props.placeholderSrc;
      return imageUrl ? { backgroundImage: 'url(\'' + imageUrl + '\')' } : {};
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var isVisible = this.state.isVisible;
      var children = this.props.children;


      return _react2.default.createElement(
        'div',
        {
          ref: function ref(el) {
            _this3.imageContainer = el;
          },
          style: this.imageStyle(),
          className: (0, _classnames3.default)(styles.image)
        },
        _react2.default.createElement('div', {
          className: (0, _classnames3.default)(styles.fallback, _defineProperty({}, styles.fadeout, isVisible)),
          style: this.placeholderImageStyle()
        }),
        children && _react2.default.createElement(
          'div',
          { className: styles.content },
          children
        )
      );
    }
  }]);

  return BackgroundImage;
}(_react2.default.Component);

BackgroundImage.displayName = 'BackgroundImage';


BackgroundImage.propTypes = {
  /**
   * The image url. If provided an image url with placeholders for the width
   * and height `{w}` and `{h}` it will load the correct size for
   * the use of this image.
   */
  src: _propTypes2.default.string.isRequired,
  /** Image url to be used as the custom placeholder and fallback image  */
  placeholderSrc: _propTypes2.default.string,
  children: _propTypes2.default.node,
  /**
   * A custom lazy loader. If provided, BackgroundImage will use the custom lazy loader to load it's images.
   * If lazy loading is supported (i.e. not server rendered) then the loader must have observe and unobserve functions.
   * Use `lazyLoader.js` as a reference
   */
  lazyLoader: _propTypes2.default.shape({
    isSupported: _propTypes2.default.bool.isRequired,
    observe: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.func, function (props) {
      return props.isSupported;
    }),
    unobserve: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.func, function (props) {
      return props.isSupported;
    })
  })
};

BackgroundImage.defaultProps = {
  placeholderSrc: null,
  children: null,
  lazyLoader: undefined
};

exports.default = BackgroundImage;